import { isResponseOk, useFetch } from "@swa-ui/fetch";

export const useCheckUsernameAvailabilityServices = () => {
  const { loading, post, response } = useFetch("/api/security/v4/security", {
    cachePolicy: "no-cache",
  });

  return {
    checkUsernameAvailability,
    loading,
  };

  async function checkUsernameAvailability(username) {
    let callStatus = { ok: true };
    const body = await post("username-availability", { username });

    if (!isResponseOk(response)) {
      callStatus = { errorCode: body?.code, ok: false, status: response?.status };
    }

    return { callStatus };
  }
};
